import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Mimecast } from "@graylog/enterprise-api";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const handleSubmit = () => {
    var _a, _b, _c, _d, _e;
    const fetcher = Mimecast.checkCredentials({
      base_url: ((_a = formData == null ? void 0 : formData.baseUrl) == null ? void 0 : _a.value) || "",
      access_key: ((_b = formData == null ? void 0 : formData.accessKey) == null ? void 0 : _b.value) || "",
      secret_key: ((_c = formData == null ? void 0 : formData.secretKey) == null ? void 0 : _c.value) || "",
      application_id: ((_d = formData == null ? void 0 : formData.applicationId) == null ? void 0 : _d.value) || "",
      application_key: ((_e = formData == null ? void 0 : formData.applicationKey) == null ? void 0 : _e.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Mimecast using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Mimecast using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(
    ["mimecastName", "baseUrl", "accessKey", "secretKey", "applicationId", "applicationKey"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      className: "col-md-7",
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "mimecastName",
        type: "text",
        fieldData: formData.mimecastName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "baseUrl",
        type: "text",
        fieldData: formData.baseUrl,
        onChange,
        label: "Mimecast Base Url",
        help: "The base API url for your Mimecase instance. (e.g. https://<region>-api.mimecast.com)",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "applicationId",
        type: "text",
        onChange,
        fieldData: formData.applicationId,
        label: "Application ID",
        help: "The ID of the Mimecast API application.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "applicationKey",
        type: "password",
        onChange,
        fieldData: formData.applicationKey,
        label: "Application Key",
        help: "The application key used for authentication.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "accessKey",
        type: "text",
        onChange,
        fieldData: formData.accessKey,
        label: "Access Key",
        help: "The Access Key for the authorized API user account.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "secretKey",
        type: "password",
        onChange,
        fieldData: formData.secretKey,
        label: "Secret Key",
        help: "The Secret Key for the authorized API user account.",
        required: true
      }
    )
  );
};
export default StepAuthorize;
